import { log } from "util";

export default {
    LOCIN_IN(state, token) {
        state.UserToken = token
    },
    MODIFY_USER(state,param){
        console.log(param);
        state.user = param
    }
}


// WEBPACK FOOTER //
// ./src/store/mutations.js